export function checkAuthentication() {
    const token = localStorage.getItem('userToken');

    return !!token;
}

export function handleDeauth() {
    // Set a flag so the login page can show a session-expired message
    sessionStorage.setItem('sessionExpired', '1');
    localStorage.clear();
}
